module.exports = __webpack_public_path__ + "img/premiere-logo.bff32fbb.png";